module.exports = {
	"config": {
		"siteTitle": "BBQ Agency",
		"siteDescr": "front-end concept",
		"siteAuthor": "Ihor Orlovskyi",
		"siteLinkedinUrl": "",
		"siteFbUrl": "",
		"siteGithubUrl": "https://github.com/coriolan-ui/coriolan-ui",
		"siteSoundcloudUrl": "",
		"siteInstagramUrl": "",
		"siteGpUrl": "",
		"siteTwitterUrl": "",
		"poweredUrl": "http://bbq-agency.github.io",
		"poweredTitle": "BBQ Agency",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/ihororlovskyi/work/github/bbq-agency.github.io/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/ihororlovskyi/work/github/bbq-agency.github.io/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"title": "Page Not Found",
				"layout": "Page",
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx",
				"absolute": "/Users/ihororlovskyi/work/github/bbq-agency.github.io/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages",
				"base": "contacts.md",
				"ext": "md",
				"name": "contacts",
				"extname": ".md",
				"basename": "contacts.md",
				"dirname": "pages",
				"stem": "contacts",
				"path": "pages/contacts.md",
				"absolute": "/Users/ihororlovskyi/work/github/bbq-agency.github.io/pages/contacts.md",
				"isAbsolute": false
			},
			"requirePath": "pages/contacts.md",
			"path": "/contacts/",
			"data": {
				"title": "Contacts | BBQ Agency",
				"layout": "Contacts",
				"path": "/contacts/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages",
				"stem": "index",
				"path": "pages/index.md",
				"absolute": "/Users/ihororlovskyi/work/github/bbq-agency.github.io/pages/index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/index.md",
			"path": "/",
			"data": {
				"title": "BBQ Agency",
				"layout": "Home",
				"path": "/"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 382
// module chunks = 0